import React, { Component } from 'react';
import {
  Droppable,
  Draggable,
} from 'react-beautiful-dnd';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

export class DragTrComponent extends Component {
  render() {
    const { children = null, rowInfo } = this.props;
    if (rowInfo) {
      const { original, index } = rowInfo;
      const id = original._id || original.id;

      return (
        <Draggable key={id} index={index} draggableId={id}>
          {(draggableProvided, draggableSnapshot) => (
            <div
              ref={draggableProvided.innerRef}
              {...draggableProvided.draggableProps}
              {...draggableProvided.dragHandleProps}
            >
              <ReactTable.defaultProps.TrComponent>
                {children}
              </ReactTable.defaultProps.TrComponent>
            </div>
          )}
        </Draggable>
      );
    } else
      return (
        <ReactTable.defaultProps.TrComponent>
          {children}
        </ReactTable.defaultProps.TrComponent>
      );
  }
}

export class DropTbodyComponent extends Component {
  render() {
    const { children = null } = this.props;

    return (
      <Droppable droppableId="droppable">
        {(droppableProvided, droppableSnapshot) => (
          <div ref={droppableProvided.innerRef}>
            <ReactTable.defaultProps.TbodyComponent>
              {children}
            </ReactTable.defaultProps.TbodyComponent>
          </div>
        )}
      </Droppable>
    );
  }
}
